<template>
    <v-card class="mb-6">
        <v-toolbar flat dense color="white lighten-2">
            <v-toolbar-title>Parametry</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
            <v-container class="pa-0">
                <v-row>
                    <v-col cols="12">
                        <table class="table table--simple">
                            <tbody>
                                <tr>
                                    <th>Nr zamówienia:</th>
                                    <td>{{ parseEmptyValue(reportData.objectNumber) }}</td>
                                </tr>
                                <tr v-if="isTypeIdValid">
                                    <th>Produkt:</th>
                                    <td>{{ reportData.objectDetail.reportItemPlateOrders[0].productName }}</td>
                                </tr>
                                <tr>
                                    <th>Nakład:</th>
                                    <td>{{ parseEmptyValue(reportData.objectDetail.amount) }}</td>
                                </tr>
                                <tr v-for="(item) in taskParameters" :key="item.id">
                                    <th>
                                        {{ item.name | capitalize }}:
                                    </th>
                                    <td v-if="item.name !== 'składki'">
                                        {{ parseEmptyValue(item.value) }}
                                    </td>
                                    <td v-else>
                                        <template v-if="item.value.length > 0">
                                            <p v-for="foldedSignature in item.value" :key="foldedSignature.id" class="ma-0">
                                                opis: {{ foldedSignature.description }}, <br>
                                                ilość stron: {{ foldedSignature.pages }}, <br>
                                                ilość: {{ foldedSignature.quantity }}
                                            </p>
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Maszyna:</th>
                                    <td>{{ parseEmptyValue(reportData.machineName) }}</td>
                                </tr>
                                <tr>
                                    <th>Proces:</th>
                                    <td>{{ reportData.processName }}</td>
                                </tr>
                                <tr>
                                    <th>Pozostały nakład:</th>
                                    <td>{{ parseEmptyValue(reportData.leftAmount) }}</td>
                                </tr>
                                <template v-if="isReportFinished">
                                    <tr>
                                        <th>Wykonany nakład:</th>
                                        <td>
                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                <template #activator="{on}">
                                                    <v-btn
                                                        v-if="reportsAdminUser"
                                                        icon
                                                        data-sentry-label="Edytuj ilość"
                                                        :disabled="!editableReportAmount"
                                                        v-on="on"
                                                        @click="editReportAmount()"
                                                    >
                                                        <v-icon small color="info">
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Edytuj zaraportowaną ilość</span>
                                            </v-tooltip>
                                            {{ reportData.reportAmount }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Ilość osób:</th>
                                        <td>{{ parseEmptyValue(reportData.machineStuffAmount) }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { hasUserPermission } from '@/utils/permissionsHandler'
import { sortBy } from 'lodash'
import parse from '@/mixins/parse'
import priceFormatter from '@/mixins/priceFormatter'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'ReportParametersData',
    mixins: [ priceFormatter, parse, tooltipDelay ],
    props: {
        reportData: {
            type: Object,
            default: null
        },
    },
    computed: {
        isTypeIdValid() {
            return [15, 40, 50, 60].includes(this.reportData.objectDetail.reportItemType) // orders only
        },
        isReportFinished() {
            return this.reportData?.statusId == 99
        },
        editableReportAmount() {
            const APPROVED = 20

            return this.report?.shiftReportStatusId != APPROVED
        },
        reportsAdminUser() {
            return hasUserPermission('reports_admin_update')
        },
        taskParameters() {
            const sortedList = [
                'format',
                'objętość',
                'składki',
                'rodzaj oprawy',
                'papier wnętrz',
                'uszlachetnianie wnętrz',
                'papier okładki',
                'uszlachetnianie okładki',
            ]

            return sortBy(this.reportData.objectDetail?.reportItemPlateParameters, item => {
                return sortedList.indexOf(item.name)
            })
        },
    },
    methods: {
        editReportAmount() {
            this.$emit('edit-report-amount', this.reportData.id)
        }
    }
}
</script>